/* Ninepine shipping widget | New Zealand
   Idempotent: one 1s tick re-reads the DOM and rewrites every widget it finds.
   Combined-listing colour switches replace the product section, so nothing in
   here holds a node reference between ticks. */
(function () {
  if (window.__npShippingWidget) return;
  window.__npShippingWidget = true;

  // ---- market config ----
  var ZONE = 'Europe/Stockholm';
  var CUTOFF_HOUR = 15;
  var TRANSIT_DAYS = 2;
  var HIDE_SAT_COUNTDOWN = true;
  var SHOW_DELIVERY = true;
  var HIDE_IF_SHIP_DAYS_OUT = 0; // 0 = never
  // Extended holiday set. Easter-derived entries are 2026 dates, update yearly.
  var HOLIDAYS = [[1,1],[1,6],[4,2],[4,3],[4,4],[4,5],[4,6],[4,18],[4,20],[4,21],[5,1],[5,14],[5,29],[6,6],[6,8],[6,19],[6,21],[11,1],[12,24],[12,25],[12,26],[12,31]];
  var BLACKOUT = [[4,2],[4,3],[4,4],[4,5],[4,6],[5,14],[6,19]];
  // ----

  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var cache = { key: null, data: null };

  function hit(list, d) {
    for (var i = 0; i < list.length; i++) if (d.month === list[i][0] && d.day === list[i][1]) return true;
    return false;
  }
  function isHoliday(d) { return hit(HOLIDAYS, d); }

  function addBusinessDays(d, n) {
    while (n > 0) {
      d = d.plus({ days: 1 });
      if (d.weekday < 6 && !isHoliday(d)) n--;
    }
    return d;
  }

  function compute(now) {
    var day = now.weekday, hour = now.hour, ship;
    if (day >= 1 && day <= 5 && hour < CUTOFF_HOUR && !isHoliday(now)) ship = now;
    else ship = addBusinessDays(now, 1);
    var delivery = addBusinessDays(ship, TRANSIT_DAYS);

    function label(d) {
      if (d.hasSame(now, 'day')) return 'Today';
      if (d.hasSame(now.plus({ days: 1 }), 'day')) return 'Tomorrow';
      return MONTHS[d.month - 1] + ' ' + d.day;
    }

    var hide = day === 5 || hit(BLACKOUT, now);
    if (HIDE_IF_SHIP_DAYS_OUT && Math.ceil(ship.diff(now, 'days').days) >= HIDE_IF_SHIP_DAYS_OUT) hide = true;

    return {
      ship: label(ship),
      delivery: label(delivery),
      hideWidget: hide,
      hideCountdown: (day === 5 && hour >= CUTOFF_HOUR) || (HIDE_SAT_COUNTDOWN && day === 6)
    };
  }

  function pad(n) { return String(Math.max(0, Math.floor(n || 0))).padStart(2, '0'); }

  function setAll(sel, val) {
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) if (els[i].textContent !== val) els[i].textContent = val;
  }

  function tick() {
    if (!window.luxon) return;
    var now = luxon.DateTime.now().setZone(ZONE);
    var key = now.toISODate() + (now.hour >= CUTOFF_HOUR ? 'B' : 'A');
    if (cache.key !== key) { cache.key = key; cache.data = compute(now); }
    var d = cache.data;

    var boxes = document.querySelectorAll('.delivery__container');
    for (var i = 0; i < boxes.length; i++) boxes[i].style.display = d.hideWidget ? 'none' : 'block';

    setAll('.date__estimated', d.ship);
    if (SHOW_DELIVERY) setAll('.date__delivery', d.delivery);

    var base = now.hour >= CUTOFF_HOUR ? now.plus({ days: 1 }) : now;
    var target = base.set({ hour: CUTOFF_HOUR, minute: 0, second: 0, millisecond: 0 });
    var r = target.diff(now, ['hours', 'minutes', 'seconds']).toObject();
    var text = pad(r.hours) + ':' + pad(r.minutes) + ':' + pad(r.seconds);

    var timers = document.querySelectorAll('.countdown__timer');
    for (var j = 0; j < timers.length; j++) {
      timers[j].style.display = d.hideCountdown ? 'none' : '';
      var t = timers[j].querySelector('.countdown__time');
      if (t && t.textContent !== text) t.textContent = text;
    }
  }

  var queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; tick(); });
  }

  function boot() {
    if (!window.luxon) { setTimeout(boot, 50); return; }
    tick();
    setInterval(tick, 1000);
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function (recs) {
        for (var i = 0; i < recs.length; i++) {
          var a = recs[i].addedNodes;
          for (var j = 0; j < a.length; j++) {
            var n = a[j];
            if (n.nodeType !== 1) continue;
            if ((n.matches && n.matches('.delivery__container')) || (n.querySelector && n.querySelector('.delivery__container'))) { soon(); return; }
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
    ['shopify:section:load', 'popstate', 'pageshow'].forEach(function (e) { window.addEventListener(e, soon); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
